
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#000","d":"M17.29 10.413c.454.454.599 1.166.304 1.775l-2.229 4.629-1.865-3.208.097-.202 1.235-2.571a1.55 1.55 0 01.415-.524 2.631 2.631 0 01-1.474-2.369 2.622 2.622 0 012.614-2.63A2.622 2.622 0 0119 7.942a2.63 2.63 0 01-1.71 2.47zm.783-2.47c0-.926-.753-1.681-1.686-1.681-.934 0-1.687.755-1.687 1.681 0 .927.753 1.681 1.687 1.681.933 0 1.686-.754 1.686-1.68zm-6.245.184a3.178 3.178 0 10-6.357.002 3.178 3.178 0 006.357-.002zm.927 0c0 2.281-1.84 4.127-4.105 4.127-2.265 0-4.105-1.846-4.105-4.127C4.545 5.847 6.385 4 8.65 4c2.264 0 4.105 1.846 4.105 4.127zm-.3 6.682a.481.481 0 01.167-.65.458.458 0 01.634.171l3.185 5.588a.481.481 0 01-.166.65.458.458 0 01-.634-.171l-3.185-5.588zm4.411-2.989a.718.718 0 00-.34-.952.73.73 0 00-.967.337l-1.137 2.366.876 1.507 1.568-3.258zm-5.89 3.536l-1.488-1.062a.663.663 0 00-.919.134l-3.507 4.56a.667.667 0 00.11.921c.13.094.277.141.427.141a.657.657 0 00.525-.257l3.12-4.055.358.26 2.43 1.755a.616.616 0 00.403.12l-1.458-2.517zm-4.118 5.017A1.57 1.57 0 015.6 21c-.34 0-.673-.108-.976-.325a1.637 1.637 0 01-.292-2.272l3.512-4.565a1.574 1.574 0 012.179-.32l1.567 1.118.133.147 1.981 3.417-.307.26a1.537 1.537 0 01-1.902.066l-2.067-1.493-2.569 3.34z"}}),_c('path',{attrs:{"fill":"#FF4F72","d":"M18.848 8.485a3.636 3.636 0 110-7.273 3.636 3.636 0 010 7.273zm.03-6.06a.455.455 0 00-.454.454V5a.455.455 0 00.91 0V2.879a.455.455 0 00-.455-.455zm-.03 4.666a.515.515 0 100-1.03.515.515 0 000 1.03z"}})])])
          )
        }
      }
    